export default class PopupClosedByUser extends Error {
  constructor() {
    super(
      "The popup has been closed before finalizing the connection, please try again"
    );
  }
}
